<template>
    <v-container>
        <v-card class="mb-10">
            <v-row align="center">
                <v-col cols=9>
                    <v-card-title class="card-title">Φόρμα Εξόδου</v-card-title>
                    <v-card-subtitle style="color: red">{{ this.$route.query.copy ? '(αντίγραφο)' : '' }} </v-card-subtitle>
                </v-col>
                <v-col cols=3 align="end" class="pr-5">
                    <v-btn v-if="this.$route.query.copy" outlined @click="$router.go(-1)"> <v-icon> mdi-arrow-left</v-icon>back </v-btn>
                    <v-btn v-else outlined @click="createCopy()"> make copy </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-form :readonly="readOnly">
            <v-row>
                <v-col cols="6">
                    <v-autocomplete
                        v-model="selectedChargeUnitsByLevel[cuLevel]"
                        :items="getFilteredChargeUnits()"
                        :item-text="item => `${item.title}(${item.code})`"
                        placeholder="Επέλεξε Μονάδα Χρέωσης"
                        :label="getChargeUnitPath()"
                        hide-details
                        return-object
                        :menu-props="{closeOnContentClick:true}"
                        @change="setCuLevel"
                    >
                        <template v-slot:prepend-inner>
                            <v-btn v-if="cuLevel >= 1 && Object.keys(selectedChargeUnitsByLevel[1]).length > 0" icon small dark color="black" @click="clearChargeUnitPath">
                                <v-icon>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="6">
                    <v-autocomplete
                        v-model="selectedCategoriesByLevel[level]"
                        :items="getFilteredCategories()"
                        :item-text="item => `${item.title}(${item.code})`"
                        placeholder="Επέλεξε Κατηγορία"
                        :label="getCategoryPath()"
                        hide-details
                        return-object
                        :menu-props="{closeOnContentClick:true}"
                        @change="setLevel"
                    >
                        <template v-slot:prepend-inner>
                            <v-btn v-if="level >= 1 && Object.keys(selectedCategoriesByLevel[1]).length > 0" icon small dark color="black" @click="clearCategoryPath">
                                <v-icon>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        v-model="expense.title"
                        label="Τίτλος"
                        type="text"
                        :clearable="clearable"
                        :error-messages="titleRule ? 'Ο συγκεκριμένος τίτλος χρησιμοποιείται ήδη' : []"
                        @change="checkExisting"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="expense.description"
                        label="Περιγραφή"
                        type="text"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        v-model="expense.amount"
                        label="Σύνολο/Μεικτά"
                        :rules="numberRules"
                        suffix="€"
                        type="number"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        v-model="expense.fpa"
                        label="Φόρος"
                        suffix="%"
                        type="number"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        :value="computedCleanMoney"
                        label="Σύνολο/Καθαρά"
                        :rules="numberRules"
                        disabled
                        suffix="€"
                        type="number"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        v-model="expense.withholding"
                        label="Παρακράτηση"
                        suffix="%"
                        type="number"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        :value="computedFinalMoney"
                        label="Σύνολο/Τελικό"
                        disabled
                        :rules="numberRules"
                        suffix="€"
                        type="number"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="4" v-if="$route.query.calendar">
                    <v-text-field
                        :value="expense.chargeUnit.wage"
                        label="Μεροκάματο"
                        disabled
                        :rules="numberRules"
                        suffix="€"
                        type="number"
                    />
                </v-col>
                <v-col cols="4" v-if="$route.query.calendar">
                    <v-text-field
                        v-model="wagePercentage"
                        label="Ποσοστό μεροκάματου"
                        :rules="numberRules"
                        suffix="€"
                        type="number"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedExpenseDate"
                                label="Ημερομηνία εξόδου"
                                :rules="rules"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="expense.expenseDate" @input="menu = false" />
                    </v-menu>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete
                        v-model="expense.status"
                        :items="status"
                        :rules="rules"
                        menu-props="auto"
                        label="Κατάσταση"
                        hide-details
                        :clearable="!readOnly"
                        item-text="displayValue"
                        item-value="value"
                    />
                </v-col>
                <v-col cols="4">
                    <v-autocomplete
                        v-model="expense.paymentMethod"
                        :items="paymentMethod"
                        menu-props="auto"
                        :rules="rules"
                        label="Μέθοδος πληρωμής"
                        hide-details
                        :clearable="!readOnly"
                        item-text="displayValue"
                        item-value="value"
                    />
                </v-col>
            </v-row>
            <v-row v-if="expense.paymentMethod === 'CASH'">
                <v-col cols="8">
                    <v-text-field
                        v-model="expense.expenseInfo.cashOnName"
                        label="Όνομα αναφοράς μετρητών"
                        type="text"
                        :clearable="clearable"
                    />
                </v-col>
            </v-row>
            <v-row v-else-if="expense.paymentMethod === 'CHECK'">
                <v-col cols="3">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedCheckDate"
                                label="Ημερομηνία έκδοσης επιταγής"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="expense.expenseInfo.checkDate" @input="menu2 = false" />
                    </v-menu>
                </v-col>
                <v-col cols="3">
                    <v-menu
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedCheckExpirationDate"
                                label="Ημερομηνία λήξης επιταγής"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="expense.expenseInfo.checkExpirationDate" @input="menu3 = false" />
                    </v-menu>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        v-model="expense.expenseInfo.checkNumber"
                        label="Αριθμός επιταγής"
                        type="number"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="3">
                    <v-select
                        v-model="expense.expenseInfo.checkBank"
                        :items="banks"
                        label="Τράπεζα"
                        type="text"
                        :clearable="clearable"
                    />
                </v-col>
            </v-row>
            <v-row v-if="expense.paymentMethod !== 'OFF_RECORD'">
                <v-col :cols="expense.invoiceType ? 4 : 12">
                    <v-autocomplete
                        v-model="expense.invoiceType"
                        :items="invoiceType"
                        menu-props="auto"
                        label="Τύπος τιμολογίου"
                        hide-details
                        :clearable="!readOnly"
                        item-text="displayValue"
                        item-value="value"
                    />
                </v-col>
                <!-- <v-col v-if="expense.invoiceType" cols="4">
                    <v-text-field
                        v-model="expense.expenseInfo.invoiceId"
                        label="ID τιμολογίου"
                        type="text"
                        :clearable="clearable"
                    />
                </v-col> -->
                <v-col v-if="expense.invoiceType" cols="4">
                    <v-text-field
                        v-model="expense.expenseInfo.invoiceNumber"
                        label="Αριθμός τιμολογίου"
                        type="text"
                        :clearable="clearable"
                    />
                </v-col>
            </v-row>
            <v-row v-if="this.expense.category.id !== 50" style="background-color:rgb(241, 241, 241);">
                <v-col v-if="!addBankExpense" cols=12>
                    Προσθήκη Τραπεζικού εξόδου
                    <v-btn fab small color=black dark class="elevation-0" @click="addBankExpense = !addBankExpense">
                        <v-icon> mdi-plus</v-icon>
                    </v-btn>
                </v-col>
                <v-col v-else cols=12>
                    Τραπεζικό Έξοδο
                    <v-col cols="6">
                        <v-text-field
                            v-model="bankExpense.title"
                            label="Τίτλος"
                            type="text"
                            :clearable="clearable"
                            @change="checkExisting"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="bankExpense.description"
                            label="Περιγραφή"
                            type="text"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="bankExpense.amount"
                            label="Σύνολο/Μεικτά"
                            :rules="numberRules"
                            suffix="€"
                            type="number"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="bankExpense.fpa"
                            label="Φόρος"
                            suffix="%"
                            type="number"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                            v-model="bankExpense.withholding"
                            label="Παρακράτηση"
                            suffix="%"
                            type="number"
                            :clearable="clearable"
                        />
                    </v-col>
                </v-col>
            </v-row>
            <!-- <v-row>
                <v-dialog
                    v-model="installmentDialog"
                    persistent
                    max-width="70%"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="mx-5 my-2"
                            dark
                            small
                            color="black"
                            v-bind="attrs"
                            v-on="on"
                        > <v-icon>mdi-plus</v-icon>Προσθήκη δόσης </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Δόση</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col
                                        cols="6"
                                    >
                                        <v-menu
                                            v-model="menu4"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="computedInstallmentDate"
                                                    label="Ημερομηνία δόσης"
                                                    :rules="rules"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker v-model="installmentDate" @input="menu4 = false" />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="installmentAmount"
                                            label="Σύνολο δόσης"
                                            :rules="numberRules"
                                            suffix="€"
                                            type="number"
                                            :clearable="clearable"
                                        />
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="installmentDescription"
                                            label="Περιγραφή"
                                            :clearable="clearable"
                                        />
                                    </v-col>
                                    <v-col cols="6">
                                        <v-autocomplete
                                            v-model="installmentPaymentMethod"
                                            :items="paymentMethod"
                                            menu-props="auto"
                                            :rules="rules"
                                            label="Μέθοδος πληρωμής"
                                            hide-details
                                            :clearable="!readOnly"
                                            return-object
                                        />
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-btn
                                        class="mx-5 my-2 white--text"
                                        dark
                                        small
                                        color="black"
                                        :disabled="installmentAmount <= 0 || !installmentDate"
                                        @click="onInstallmentSubmit"
                                    > Καταχώριση</v-btn>
                                    <v-btn
                                        class="mx-5 my-2"
                                        dark
                                        small
                                        color="red"
                                        @click="installmentDialog = false"
                                    > Ακύρωση </v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row v-if="hasInstallments" justify="center">
                <v-col cols="12">
                    <v-card class="my-2">
                        <v-row>
                            <v-col cols="3">
                                <v-card-title>
                                    Δόσεις
                                </v-card-title>
                            </v-col>
                            <v-col cols="5">
                                <v-card-text v-if="expense.amount">
                                    Υπόλοιπο: {{ expense.amount - totalInstallmentAmount }} €
                                </v-card-text>
                            </v-col>
                            <v-col cols="4">
                                <v-card-text>
                                    Πληρωτέο: {{ totalInstallmentAmount }} €
                                </v-card-text>
                            </v-col>
                        </v-row>
                        <v-timeline side="end" dense class="my-2">
                            <v-timeline-item
                                v-for="(installment, index) in expense.expenseInfo.installments"
                                :key="installment.installmentDate"
                                color="red"
                                small
                            >
                                <div class="installment">
                                    <div class="font-weight-normal">
                                        <strong>{{ getDateFormated(installment.installmentDate) }}</strong>
                                        <v-icon class="mx-2">
                                            mdi-arrow-top-right
                                        </v-icon>
                                        Ποσό: {{ installment.amount }} € /
                                        Περιγραφή: {{ installment.description }} /
                                        Μέθοδος πληρωμής: {{ installment.paymentMethod }}
                                    </div>
                                    <v-btn
                                        class="mx-5 my-2"
                                        dark
                                        max-width="20"
                                        max-height="20"
                                        fab
                                        color="red"
                                        @click="removeInstallment(index)"
                                    > <v-icon>mdi-minus</v-icon></v-btn>
                                </div>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card>
                </v-col>
            </v-row> -->
        </v-form>
        <div v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit()" :loading="loading" large color="black" @click="onSubmit">
                Καταχώριση
            </v-btn>
            <v-btn class="mx-2 white--text" large color="red" @click="$router.push({name:'Expenses', query:{ page: $route.query.page, size:$route.query.size} })">
                Ακύρωση
            </v-btn>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import expenseService from '@/services/expense'
    import Alert from '@/components/Alert'
    import categoryService from '@/services/category'
    import chargeUnitService from '@/services/chargeUnit'
    import momentTimezone from 'moment-timezone'

    export default {
        name: 'ExpenseForm',
        components: { Alert },
        data: () => {
            return {
                wagePercentage: 100,
                menu: false,
                menu2: false,
                menu3: false,
                menu4: false,
                installmentDate: null,
                installmentAmount: 0,
                installmentDialog: false,
                installmentDescription: '',
                installmentPaymentMethod: null,
                banks: ['ALPHA', 'ΠΕΙΡΑΙΩΣ', 'ΕΘΝΙΚΗ', 'EUROBANK'],
                invoiceType: [
                    { displayValue: 'ΤΙΜΟΛΟΓΙΟ ΠΑΡΟΧΗΣ ΥΠΗΡΕΣΙΩΝ', value: 'TPY' },
                    { displayValue: 'ΑΠΛΟ ΤΙΜΟΛΟΓΙΟ', value: 'INVOICE' },
                    { displayValue: 'ΤΙΜΟΛΟΓΙΟ/ΔΕΛΤΙΟ ΑΠΟΣΤΟΛΗΣ', value: 'TDA' },
                    { displayValue: 'ΠΙΣΤΩΤΙΚΟ ΤΙΜΟΛΟΓΙΟ', value: 'PT' }
                ],
                status: [
                    { displayValue: 'ΕΚΚΡΕΜΕΙ', value: 'PENDING' },
                    { displayValue: 'ΠΛΗΡΩΜΕΝΟ', value: 'PAID' },
                    { displayValue: 'ΑΚΥΡΩΜΕΝΟ', value: 'CANCELED' }
                ],
                paymentMethod: [
                    { displayValue: 'ΜΕΤΡΗΤΑ', value: 'CASH' },
                    { displayValue: 'ΕΠΙΤΑΓΗ', value: 'CHECK' },
                    { displayValue: 'ΤΡΑΠΕΖΑ', value: 'BANK' },
                    { displayValue: 'ΚΟΥΠΟΝΙΑ', value: 'COUPONS' }
                ],
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                level: 1,
                cuLevel: 1,
                categories: [],
                chargeUnits: [],
                selectedCategoriesByLevel: { 1: {} },
                selectedChargeUnitsByLevel: { 1: {} },
                expense: {
                    chargeUnit: {},
                    category: {},
                    expenseInfo: {
                        installments: []
                    },
                    fpa: 0,
                    withholding: 0
                },
                readOnly: false,
                clearable: true,
                rules: [
                    v => !!v || 'Field is required'
                ],
                numberRules: [
                    v => (!!v && v > 0) || 'Field is required and > 0'
                ],
                titleRule: false,
                addBankExpense: false,
                bankExpense: {
                    chargeUnit: {},
                    category: {},
                    expenseInfo: {
                        installments: []
                    },
                    fpa: 0,
                    withholding: 0
                }
            }
        },
        watch: {
            wagePercentage() {
                this.expense.amount = this.expense.chargeUnit.wage * (this.wagePercentage / 100)
                console.log(this.expense.amount)
            },
            'expense.invoiceType': {
                handler() {
                    if (!this.expense.expenseInfo) {
                        this.expense.expenseInfo = {}
                    }
                }
            }
        },
        computed: {
            getDateFormated(date) {
                return momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY').toString()
            },
            totalInstallmentAmount() {
                let total = 0
                const installments = this.expense.expenseInfo.installments
                if (!installments) {
                    return total
                }
                for (const installment of installments) {
                    total += installment.amount
                }
                return total
            },
            hasInstallments() {
                return this.expense.expenseInfo?.installments && this.expense.expenseInfo?.installments.length > 0
            },
            computedExpenseDate() {
                return this.expense.expenseDate ? momentTimezone(this.expense.expenseDate).tz('Europe/Athens').format('DD/MM/YYYY') : ''
            },
            computedCheckDate() {
                return this.expense.expenseInfo.checkDate ? momentTimezone(this.expense.expenseInfo.checkDate).tz('Europe/Athens').format('DD/MM/YYYY') : ''
            },
            computedCheckExpirationDate() {
                return this.expense.expenseInfo.checkExpirationDate ? momentTimezone(this.expense.expenseInfo.checkExpirationDate).tz('Europe/Athens').format('DD/MM/YYYY') : ''
            },
            computedInstallmentDate() {
                return this.installmentDate ? momentTimezone(this.installmentDate).tz('Europe/Athens').format('DD/MM/YYYY') : ''
            },
            computedCleanMoney() {
                return this.expense.amount / (1 + this.expense.fpa / 100)
            },
            computedFinalMoney() {
                return this.expense.amount - ((this.expense.withholding / 100) * this.computedCleanMoney)
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            this.expenseId = this.$route.params.expenseId

            this.getCategories()
            this.getChargeUnits()

            if (this.$route.params.expenseId) {
                expenseService.getExpense(this.$route.params.expenseId)
                    .then(resp => {
                        this.expense = resp.data
                        this.level = this.expense.category.level
                        this.cuLevel = this.expense.chargeUnit.level
                        this.expense.expenseDate = momentTimezone(this.expense.expenseDate).tz('Europe/Athens').format('YYYY-MM-DD').toString()
                        this.initSelectedCategoriesByLevel()
                        this.initSelectedChargeUnitsByLevel()
                        if (this.expense.paymentMethod === 'CASH') {
                            if (!this.expense.expenseInfo) {
                                this.expense.expenseInfo = {}
                                this.expense.expenseInfo.cashOnName = ''
                            }
                        }
                    })
            } else if (this.$route.query.copy) {
                let data = this.$store.getters.getTempExpense
                this.expense = data.expense
                this.bankExpense = data.bankExpense
                this.addBankExpense = data.addBankExpense
                this.selectedCategoriesByLevel = data.selectedCategoriesByLevel
                this.selectedChargeUnitsByLevel = data.selectedChargeUnitsByLevel
                this.level = data.level
                this.cuLevel = data.cuLevel
            }
        },
        methods: {
            createCopy() {
                this.$store.dispatch('setTempExpense', {
                    expense: this.expense,
                    bankExpense: this.bankExpense,
                    addBankExpense: this.addBankExpense,
                    selectedCategoriesByLevel: this.selectedCategoriesByLevel,
                    selectedChargeUnitsByLevel: this.selectedChargeUnitsByLevel,
                    level: this.level,
                    cuLevel: this.cuLevel
                })
                this.$router.push({
                    path: '/expenses/create',
                    params: { mode: 'create' },
                    query: { page: this.$route.query.page, size: this.$route.query.size, copy: true }
                })
            },
            checkExisting() {
                expenseService.checkExisting(this.expense.title).then(() => {
                    this.titleRule = false
                }).catch(() => {
                    this.titleRule = true
                })
            },
            getFilteredChargeUnits() {
                return this.chargeUnits.filter((element) => {
                    if (element.level === this.cuLevel) {
                        if (element.parent === null) {
                            return element
                        } else {
                            if (element.parent.id === this.selectedChargeUnitsByLevel[this.cuLevel - 1].id) {
                                return element
                            }
                        }
                    }
                })
            },
            getFilteredCategories() {
                return this.categories.filter((element) => {
                    if (element.level === this.level) {
                        if (element.parent === null) {
                            return element
                        } else {
                            if (element.parent.id === this.selectedCategoriesByLevel[this.level - 1].id) {
                                return element
                            }
                        }
                    }
                })
            },
            initSelectedChargeUnitsByLevel() {
                let temp = this.expense.chargeUnit
                for (let index = this.expense.chargeUnit.level; index > 0; index--) {
                    this.selectedChargeUnitsByLevel[index] = temp
                    temp = temp.parent
                }
            },
            initSelectedCategoriesByLevel() {
                let temp = this.expense.category
                for (let index = this.expense.category.level; index > 0; index--) {
                    this.selectedCategoriesByLevel[index] = temp
                    temp = temp.parent
                }
            },
            clearCategoryPath() {
                this.level = 1
                this.selectedCategoriesByLevel = { 1: {} }
                this.expense.category = {}
            },
            clearChargeUnitPath() {
                this.cuLevel = 1
                this.selectedChargeUnitsByLevel = { 1: {} }
                this.expense.chargeUnit = {}
            },
            getCategoryPath() {
                let path = ''
                for (let index = this.level - 1; index > 0; index--) {
                    path += `${index === this.level - 1 ? '' : '/'}${this.selectedCategoriesByLevel[index].title}(${this.selectedCategoriesByLevel[index].code})`
                }
                return path
            },
            getChargeUnitPath() {
                let path = ''
                for (let index = this.cuLevel - 1; index > 0; index--) {
                    path += `${index === this.cuLevel - 1 ? '' : '/'}${this.selectedChargeUnitsByLevel[index].title}(${this.selectedChargeUnitsByLevel[index].code})`
                }
                return path
            },
            setLevel() {
                if (this.selectedCategoriesByLevel[this.level]) {
                    this.expense.category = this.selectedCategoriesByLevel[this.level]
                    this.level += 1
                }
            },
            setCuLevel() {
                if (this.selectedChargeUnitsByLevel[this.cuLevel]) {
                    this.expense.chargeUnit = this.selectedChargeUnitsByLevel[this.cuLevel]
                    this.cuLevel += 1
                }
            },
            getCategories() {
                categoryService.getAllCategories().then(resp => {
                    this.categories = resp.data
                })
            },
            getChargeUnits() {
                chargeUnitService.getAllChargeUnits().then(resp => {
                    this.chargeUnits = resp.data
                })
            },
            removeInstallment(installmentIndex) {
                this.expense.expenseInfo.installments.splice(installmentIndex, 1)
            },
            onInstallmentSubmit() {
                if (!this.expense.expenseInfo) {
                    this.expense.expenseInfo = {}
                    this.expense.expenseInfo.installments = []
                }
                const installmentOnDateIndex = this.expense.expenseInfo.installments.findIndex(installment => this.installmentDate === installment.installmentDate)
                if (installmentOnDateIndex >= 0) {
                    this.expense.expenseInfo.installments[installmentOnDateIndex].amount += parseFloat(this.installmentAmount)
                } else {
                    this.expense.expenseInfo.installments.push({
                        installmentDate: momentTimezone(this.installmentDate).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString(),
                        amount: parseFloat(this.installmentAmount)
                    })
                }
                this.sortInstallmentsByDate()
                this.installmentDate = null
                this.installmentAmount = null
                this.installmentDialog = false
            },
            clearExpenseInfoFields() {
                if (!this.expense.expenseInfo) {
                    delete this.expense.expenseInfo
                    // this.expense.expenseInfo = {}
                } else {
                    if (this.expense.paymentMethod !== 'CASH') {
                        this.expense.expenseInfo.cashOnName = null
                    }
                    if (this.expense.paymentMethod !== 'CHECK') {
                        this.expense.expenseInfo.checkDate = null
                        this.expense.expenseInfo.checkExpirationDate = null
                        this.expense.expenseInfo.checkNumber = null
                        this.expense.expenseInfo.checkBank = null
                    }
                    if (!this.expense.invoiceType) {
                        this.expense.expenseInfo.invoiceId = null
                        this.expense.expenseInfo.invoiceNumber = null
                    }
                    if (!this.hasInstallments) {
                        this.expense.expenseInfo.installments = null
                    }
                }
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                return !(this.expense.expenseDate && this.expense.status && this.expense.paymentMethod && this.expense.amount && this.expense.category && this.expense.chargeUnit)
            },
            createExpense() {
                this.loading = true
                expenseService.createExpense(this.expense).then(expenseResponse => {
                    if (expenseResponse.id) {
                        this.expenseId = expenseResponse.id
                    }
                }).then(() => {
                    if (this.addBankExpense && this.bankExpense.amount) {
                        let tempBankExpense = JSON.parse(JSON.stringify(this.expense))
                        tempBankExpense.amount = this.bankExpense.amount
                        tempBankExpense.description = this.bankExpense.description
                        tempBankExpense.title = this.bankExpense.title
                        tempBankExpense.fpa = this.bankExpense.fpa
                        tempBankExpense.withholding = this.bankExpense.withholding
                        tempBankExpense.category = {
                            code: 11221700,
                            id: 50,
                            level: 1,
                            parent: null,
                            title: 'ΤΡΑΠΕΖΙΚΑ ΕΞΟΔΑ'
                        }
                        expenseService.createExpense(tempBankExpense).then(() => {
                            this.loading = false
                            this.$route.query.calendar ? this.$router.go(-1) : this.$router.push(`/expenses?page=${this.$route.query.page}&size=${this.$route.query.size}`)
                        })
                    } else {
                        this.loading = false
                        this.$route.query.calendar ? this.$router.go(-1) : this.$router.push(`/expenses?page=${this.$route.query.page}&size=${this.$route.query.size}`)
                    }
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            editExpense() {
                this.loading = true
                expenseService.updateExpense(this.expense.id, this.expense).then(() => {
                    this.loading = false
                    this.$route.query.calendar ? this.$router.go(-1) : this.$router.push(`/expenses?page=${this.$route.query.page}&size=${this.$route.query.size}`)
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                    this.loading = false
                })
            },
            sortInstallmentsByDate() {
                if (!this.expense.expenseInfo.installments) {
                    return
                }
                this.expense.expenseInfo.installments.sort(function(a, b) {
                    if (a.installmentDate < b.installmentDate) return -1
                    if (a.installmentDate > b.installmentDate) return 1
                    return 0
                })
            },
            async onSubmit() {
                this.expense.expenseDate = momentTimezone(this.expense.expenseDate).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.clearExpenseInfoFields()
                console.log(this.mode)
                if (this.mode === 'edit') {
                    this.editExpense()
                } else if (this.mode === 'create') {
                    this.createExpense()
                }
            }
        }

    }
</script>
<style scoped>

.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.installment {
    display: flex;
    align-items: center;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
